import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetManufacturers } from 'core/Store/manufacturers/actions';
import { selectManufacturers } from 'core/Store/manufacturers/selector';
import { Manufacturer } from 'core/types/manufacturer';

export default function useManufacturers() {
  const showErrorNotification = useErrorNotifications();
  const [manufacturers, dispatch] = useSubstate(selectManufacturers);

  useEffect(() => {
    if (manufacturers.length) {
      return;
    }

    client()
      .get<Manufacturer[]>('manufacturers')
      .then(response => dispatch(new SetManufacturers(response.data)))
      .catch(showErrorNotification);
  }, [dispatch, manufacturers, showErrorNotification]);

  return manufacturers;
}
